'use client';

import { LoanInvestmentResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  result: LoanInvestmentResult;
  translations: ToolsTranslations['loanInvestment'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  const currencyFormat = (amount: number) => amount.toLocaleString('sv-SE') + ' kr per år';
  return (
    <div className="space-y-6">
      <div className="rounded-lg bg-gray-50 p-4 border border-gray-200">
        <div className="text-xl font-semibold text-blue-900 mb-1">{translations.profitLabel}</div>
        <div className="text-2xl font-semibold text-blue-900">{result.profitPerYear !== null ? currencyFormat(result.profitPerYear) : '—'}</div>
      </div>
      {!result.isValid && result.message && (
        <p className="text-sm text-red-600">{result.message}</p>
      )}
    </div>
  );
}


